(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // Discount code -> sets the discount cookie for checkout, confirms inline.
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-cdr-apply]");
    if (!btn) return;
    var drawer = btn.closest("cart-drawer");
    var input = drawer.querySelector("[data-cdr-code]");
    var note = drawer.querySelector("[data-cdr-note]");
    var code = input && input.value.trim();
    if (!code) return;
    fetch("/discount/" + encodeURIComponent(code)).finally(function () {
      if (note) { note.hidden = false; note.textContent = "“" + code + "” will apply at checkout."; }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-collection-switcher"] && !Shopify.designMode) return;
  try {
    
  // R4 tab strip: tapping a collection name crossfades the matching product
  // rail in and centers the tab. Delegated at document level (like the
  // Guide/Lookbook tabs) so it survives theme-editor re-renders.
  document.addEventListener("click", function (e) {
    var tab = e.target.closest("[data-hcsw-tab]");
    if (!tab) return;
    var root = tab.closest("[data-hcsw-stream]");
    if (!root) return;
    var idx = tab.getAttribute("data-hcsw-tab");
    root.querySelectorAll("[data-hcsw-tab]").forEach(function (t) { t.classList.toggle("is-active", t === tab); });
    root.querySelectorAll("[data-stream-panel]").forEach(function (p) {
      var on = p.getAttribute("data-stream-panel") === idx;
      if (on === !p.hidden) return;
      if (on) {
        p.hidden = false;
        p.scrollLeft = 0;
        p.classList.add("is-fading");
        window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { p.classList.remove("is-fading"); }); });
      } else {
        p.hidden = true;
        p.classList.remove("is-fading");
      }
    });
    if (tab.scrollIntoView) tab.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  });

  // Color swatches on product cards: click/Enter swaps the card photo to that
  // color's variant image. Generic across rails (.hcsw__ + .hsbc__).
  document.querySelectorAll("[data-swatch-card]").forEach(function (card) {
    var photo = card.querySelector("img");
    card.querySelectorAll(".hcsw__swatch, .hsbc__swatch").forEach(function (sw) {
      function activate(e) {
        e.preventDefault();
        e.stopPropagation();
        var src = sw.getAttribute("data-swatch-img");
        if (photo && src) { photo.removeAttribute("srcset"); photo.setAttribute("src", src); }
        sw.parentNode.querySelectorAll(".hcsw__swatch, .hsbc__swatch").forEach(function (s) { s.classList.toggle("is-active", s === sw); });
      }
      sw.addEventListener("click", activate);
      sw.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") activate(e); });
    });
  });

  // Catalog-wide sibling discovery for the home rails (client 2026-07-24:
  // "swatches aren't appearing for every product") — same predictive-search
  // pass as the PLP: colorway families on this 2,500-product store often
  // share no collection, so the same-collection scan above comes up short.
  // One cached request per family, 4 in flight max; discovered siblings
  // append as photo dots (server hex/split dots stay), capped at 4 per card.
  (function () {
    var cache = {}, active = 0, queue = [];
    function pump() { while (active < 4 && queue.length) { active++; queue.shift()(); } }
    function fetchBase(base) {
      if (cache[base]) return cache[base];
      cache[base] = new Promise(function (resolve) {
        queue.push(function () {
          fetch("/search/suggest.json?q=" + encodeURIComponent(base) + "&resources[type]=product&resources[limit]=10")
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var out = [];
              ((((d || {}).resources || {}).results || {}).products || []).forEach(function (p) {
                if (p.title && p.title.indexOf(" - ") > -1 && p.title.split(" - ")[0].trim() === base) out.push(p);
              });
              resolve(out);
            })
            .catch(function () { resolve([]); })
            .then(function () { active--; pump(); });
        });
        pump();
      });
      return cache[base];
    }
    function img(p, w) {
      var u = (p.featured_image && p.featured_image.url) || p.image || "";
      return u ? u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w : "";
    }
    // Dots show colors only (client 2026-08-07: no product photos in
    // swatches) — unmapped names get the neutral chip.
    function bind(sw, card) {
      function activate(e) {
        e.preventDefault();
        e.stopPropagation();
        var photo = card.querySelector("img");
        var src = sw.getAttribute("data-swatch-img");
        if (photo && src) { photo.removeAttribute("srcset"); photo.setAttribute("src", src); }
        sw.parentNode.querySelectorAll(".hcsw__swatch").forEach(function (x) { x.classList.toggle("is-active", x === sw); });
      }
      sw.addEventListener("click", activate);
      sw.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") activate(e); });
    }
    function upgrade(card, matches) {
      var selfPath = (card.getAttribute("href") || "").split("?")[0];
      var seenColors = {};
      var selfColor = (card.getAttribute("data-sib-color") || "").toLowerCase();
      if (selfColor) seenColors[selfColor] = true;
      var row = card.querySelector(".hcsw__swatches");
      if (row) row.querySelectorAll(".hcsw__swatch").forEach(function (d) { seenColors[(d.title || "").toLowerCase()] = true; });
      var fresh = matches.filter(function (p) {
        if ((p.url || "").split("?")[0] === selfPath) return false;
        return !seenColors[p.title.split(" - ").pop().trim().toLowerCase()];
      });
      if (!fresh.length) return;
      if (!row) {
        row = document.createElement("span");
        row.className = "hcsw__swatches";
        var self = document.createElement("span");
        self.className = "hcsw__swatch is-active";
        self.setAttribute("role", "button");
        self.tabIndex = 0;
        self.title = card.getAttribute("data-sib-color") || "";
        var selfBg = window.gauiColorBg && window.gauiColorBg(self.title);
        var photo = card.querySelector(".hcsw__photo");
        var src = photo ? (photo.currentSrc || photo.src) : "";
        if (selfBg) self.style.background = selfBg;
        else self.style.background = "#D1CEC8";
        if (src) self.setAttribute("data-swatch-img", src);
        row.appendChild(self);
        bind(self, card);
        var meta = card.querySelector(".hcsw__meta");
        if (meta) card.insertBefore(row, meta); else card.appendChild(row);
      }
      var count = row.querySelectorAll(".hcsw__swatch").length;
      fresh.forEach(function (p) {
        if (count >= 4) return;
        var sw = document.createElement("span");
        sw.className = "hcsw__swatch";
        sw.setAttribute("role", "button");
        sw.tabIndex = 0;
        var c = p.title.split(" - ").pop().trim();
        sw.title = c;
        sw.setAttribute("aria-label", c);
        var bg = window.gauiColorBg && window.gauiColorBg(c);
        if (bg) { sw.style.background = bg; }
        else { sw.style.background = "#D1CEC8"; }
        var i600 = img(p, 600);
        if (i600) sw.setAttribute("data-swatch-img", i600);
        row.appendChild(sw);
        bind(sw, card);
        count++;
      });
    }
    function scan() {
      document.querySelectorAll("[data-swatch-card][data-sib-base]").forEach(function (c) {
        if (c.hasAttribute("data-sib-armed")) return;
        c.setAttribute("data-sib-armed", "");
        fetchBase(c.getAttribute("data-sib-base")).then(function (m) { upgrade(c, m); });
      });
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan); else scan();
    document.addEventListener("shopify:section:load", scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-explore-tiles"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll("[data-hexp]").forEach(function (root) {
    root.addEventListener("click", function (e) {
      var row = e.target.closest("[data-hexp-row]");
      if (!row) return;
      var idx = row.getAttribute("data-hexp-row");
      root.querySelectorAll("[data-hexp-row]").forEach(function (r) { r.classList.toggle("is-active", r === row); });
      root.querySelectorAll("[data-hexp-panel]").forEach(function (p) { p.hidden = p.getAttribute("data-hexp-panel") !== idx; });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-fabric-experience"] && !Shopify.designMode) return;
  try {
    
  // Meter arrow advances the fabric rail one slide (wraps to the first at
  // the end). stopPropagation keeps the whole-card tap-through from firing.
  document.addEventListener("click", function (e) {
    var next = e.target.closest("[data-hfx-next]");
    if (!next) return;
    e.preventDefault();
    e.stopPropagation();
    var rail = next.closest("[data-hfx-rail]");
    if (!rail) return;
    var slide = rail.querySelector(".hfx__banner");
    var stride = slide ? slide.getBoundingClientRect().width + 16 : rail.clientWidth;
    var atEnd = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 10;
    rail.scrollTo({ left: atEnd ? 0 : rail.scrollLeft + stride, behavior: "smooth" });
  }, true);

  // Fabric-rail swipe cue: thumb width = visible fraction, left = scroll
  // progress. Scroll doesn't bubble, so listen in capture at the document
  // level — survives theme-editor section re-renders like the other
  // delegated handlers in this theme.
  (function () {
    function hfxSync(rail) {
      var thumb = rail.parentElement.querySelector("[data-hfx-thumb]");
      if (!thumb || rail.scrollWidth <= 0) return;
      thumb.style.width = (rail.clientWidth / rail.scrollWidth) * 100 + "%";
      thumb.style.left = (rail.scrollLeft / rail.scrollWidth) * 100 + "%";
    }
    function hfxSyncAll() {
      document.querySelectorAll("[data-hfx-rail]").forEach(hfxSync);
    }
    document.addEventListener("scroll", function (e) {
      if (e.target instanceof Element && e.target.matches("[data-hfx-rail]")) hfxSync(e.target);
    }, true);
    window.addEventListener("resize", hfxSyncAll);
    document.addEventListener("shopify:section:load", hfxSyncAll);
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", hfxSyncAll);
    } else {
      hfxSyncAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero-product"] && !Shopify.designMode) return;
  try {
    
  // Read-more expander: swaps the truncated preview for the full PDP
  // content (description + colors/sizes/category) in place.
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-hprod-toggle]");
    if (!btn) return;
    var root = btn.closest("[data-hprod-desc]");
    if (!root) return;
    var preview = root.querySelector("[data-hprod-preview]");
    var full = root.querySelector("[data-hprod-full]");
    var opening = full.hidden;
    full.hidden = !opening;
    if (preview) preview.hidden = opening;
  });

  // Hero-product gallery pager: active dash follows the rail (document
  // capture, same pattern as the fabric + band rails).
  (function () {
    function hprodSync(rail) {
      var root = rail.closest(".hprod");
      if (!root) return;
      var dashes = root.querySelectorAll("[data-hprod-dashes] span");
      if (!dashes.length) return;
      var active = Math.round(rail.scrollLeft / Math.max(1, rail.clientWidth));
      if (active > dashes.length - 1) active = dashes.length - 1;
      dashes.forEach(function (d, i) { d.classList.toggle("is-on", i === active); });
      root.querySelectorAll("[data-hprod-thumb]").forEach(function (t) {
        t.classList.toggle("is-on", parseInt(t.getAttribute("data-hprod-thumb"), 10) === active);
      });
    }
    document.addEventListener("click", function (e) {
      var t = e.target.closest("[data-hprod-thumb]");
      if (!t) return;
      var root = t.closest(".hprod");
      var rail = root && root.querySelector("[data-hprod-rail]");
      if (!rail) return;
      rail.scrollTo({ left: rail.clientWidth * parseInt(t.getAttribute("data-hprod-thumb"), 10), behavior: "smooth" });
    });
    document.addEventListener("scroll", function (e) {
      if (e.target instanceof Element && e.target.matches("[data-hprod-rail]")) hprodSync(e.target);
    }, true);
    document.addEventListener("shopify:section:load", function () {
      document.querySelectorAll("[data-hprod-rail]").forEach(hprodSync);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-shop-category"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll("[data-hsbc]").forEach(function (root) {
    root.addEventListener("click", function (e) {
      var tab = e.target.closest("[data-hsbc-tab]");
      if (!tab) return;
      var idx = tab.getAttribute("data-hsbc-tab");
      root.querySelectorAll("[data-hsbc-tab]").forEach(function (t) { t.classList.toggle("is-active", t === tab); });
      root.querySelectorAll("[data-hsbc-panel]").forEach(function (p) { p.hidden = p.getAttribute("data-hsbc-panel") !== idx; });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll("[data-acct]").forEach(function (root) {
    var setTab = function (idx) {
      root.querySelectorAll("[data-acct-tab]").forEach(function (t) { t.classList.toggle("is-active", t.getAttribute("data-acct-tab") === idx); });
      root.querySelectorAll("[data-acct-panel]").forEach(function (p) {
        if (p.getAttribute("data-acct-panel") === idx) { p.removeAttribute("data-inactive"); } else { p.setAttribute("data-inactive", ""); }
      });
    };
    if (window.innerWidth < 750) setTab("0");
    root.addEventListener("click", function (e) {
      var tab = e.target.closest("[data-acct-tab]");
      if (tab) setTab(tab.getAttribute("data-acct-tab"));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-auth"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-auth-recover-open]")) {
      document.querySelector("[data-auth-login]").hidden = true;
      document.querySelector("[data-auth-recover]").hidden = false;
    }
    if (e.target.closest("[data-auth-recover-close]")) {
      document.querySelector("[data-auth-login]").hidden = false;
      document.querySelector("[data-auth-recover]").hidden = true;
    }
    var show = e.target.closest("[data-auth-show]");
    if (show) {
      var input = show.closest(".auth__pass-wrap").querySelector("input");
      var revealed = input.type === "text";
      input.type = revealed ? "password" : "text";
      show.textContent = revealed ? "Show" : "Hide";
      show.setAttribute("aria-pressed", revealed ? "false" : "true");
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll("[data-res]").forEach(function (root) {
    var sectionId = root.getAttribute("data-section-id");
    var form = root.querySelector("[data-res-filters]");
    var grid = root.querySelector("[data-res-grid]");
    var sort = root.querySelector("[data-res-sort]");
    var gridModes = ["res__grid--2", "res__grid--3", "res__grid--1"];
    var gridIdx = 0;

    // Filters open/close (desktop width-toggle / mobile sheet — CSS handles presentation)
    function syncFilterState() {
      var open = root.classList.contains("res--filters-open");
      root.querySelectorAll("[data-res-filters-open][aria-expanded]").forEach(function (b) {
        b.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }
    root.querySelectorAll("[data-res-filters-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        root.classList.toggle("res--filters-open");
        document.body.classList.toggle("drawer-open", window.innerWidth < 990 && root.classList.contains("res--filters-open"));
        syncFilterState();
      });
    });
    root.querySelectorAll("[data-res-filters-close]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        root.classList.remove("res--filters-open");
        document.body.classList.remove("drawer-open");
        syncFilterState();
      });
    });

    // Grid density toggle (2 -> 3 -> 1)
    function syncGridIcon() {
      var n = gridModes[gridIdx].slice(-1);
      root.querySelectorAll("[data-res-grid-toggle]").forEach(function (b) { b.setAttribute("data-grid-n", n); });
    }
    syncGridIcon();
    root.querySelectorAll("[data-res-grid-toggle]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        gridIdx = (gridIdx + 1) % gridModes.length;
        grid.classList.remove("res__grid--1", "res__grid--2", "res__grid--3");
        grid.classList.add(gridModes[gridIdx]);
        syncGridIcon();
      });
    });

    // Sort + filters -> AJAX via Section Rendering. applySeq drops stale
    // responses so a slow older request can't overwrite a newer render.
    var applySeq = 0;
    function apply() {
      var seq = ++applySeq;
      var params = new URLSearchParams();
      if (form) new FormData(form).forEach(function (v, k) { if (v !== "") params.append(k, v); });
      if (sort && sort.value) params.set("sort_by", sort.value);
      var qs = params.toString();
      var historyUrl = qs ? window.location.pathname + "?" + qs : window.location.pathname;
      root.classList.add("res--loading");
      fetch(window.location.pathname + "?" + (qs ? qs + "&" : "") + "section_id=" + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          if (seq !== applySeq) return;
          var doc = new DOMParser().parseFromString(text, "text/html");
          ["[data-res-grid]", "[data-product-count]", "[data-product-count-m]", "[data-product-count-inline]", "[data-res-more-wrap]"].forEach(function (sel) {
            var fresh = doc.querySelector(sel);
            var cur = root.querySelector(sel);
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          });
          if (sort) { var lbl = root.querySelector("[data-sort-label]"); if (lbl) lbl.textContent = sort.options[sort.selectedIndex].text; }
          if (history.replaceState) history.replaceState({}, "", historyUrl);
        })
        .finally(function () { if (seq === applySeq) root.classList.remove("res--loading"); });
    }
    // Keep the sheet's sort radios and the desktop select in lockstep —
    // apply() reads the select as the source of truth for sort_by.
    function syncSortRadios() {
      if (!form || !sort) return;
      form.querySelectorAll('[name="sort_by"]').forEach(function (r) { r.checked = r.value === sort.value; });
    }
    if (sort) sort.addEventListener("change", function () { syncSortRadios(); apply(); });
    if (form) {
      form.addEventListener("change", function (e) {
        if (e.target && e.target.name === "sort_by" && sort) sort.value = e.target.value;
        // Instant visual state on the styled controls (chips/swatches/checks) —
        // their inputs are hidden, so without this a tap looks like a no-op.
        if (e.target && (e.target.type === "checkbox" || e.target.type === "radio")) {
          if (e.target.type === "radio") {
            form.querySelectorAll('input[name="' + e.target.name + '"]').forEach(function (r) {
              var l = r.closest(".res__chip, .res__swatch, .res__check");
              if (l) l.classList.toggle("is-active", r.checked);
            });
          } else {
            var lbl = e.target.closest(".res__chip, .res__swatch, .res__check");
            if (lbl) lbl.classList.toggle("is-active", e.target.checked);
          }
        }
        setTimeout(apply, 250);
      });
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        apply();
        root.classList.remove("res--filters-open");
        document.body.classList.remove("drawer-open");
      });
    }

    // 1-up grid: See more toggles the clamped description
    root.addEventListener("click", function (e) {
      var more = e.target.closest("[data-rcard-more]");
      if (!more) return;
      var desc = more.parentElement.querySelector("[data-rcard-desc]");
      if (!desc) return;
      var open = desc.classList.toggle("is-open");
      more.textContent = open ? "See less" : "See more";
      more.setAttribute("aria-expanded", open ? "true" : "false");
    });

    // Load more -> fetch next page, append cards. Delegated so the button
    // survives apply() re-rendering the wrap after a filter/sort change.
    root.addEventListener("click", function (e) {
      var more = e.target.closest("[data-res-more]");
      if (!more || more.disabled) return;
      var url = more.getAttribute("data-next-url");
      if (!url) return;
      more.disabled = true;
      var join = url.indexOf("?") > -1 ? "&" : "?";
      fetch(url + join + "section_id=" + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, "text/html");
          var freshGrid = doc.querySelector("[data-res-grid]");
          if (freshGrid) Array.prototype.slice.call(freshGrid.children).forEach(function (c) { grid.appendChild(c); });
          var nextBtn = doc.querySelector("[data-res-more]");
          if (nextBtn && nextBtn.getAttribute("data-next-url")) {
            more.setAttribute("data-next-url", nextBtn.getAttribute("data-next-url"));
            more.disabled = false;
          } else {
            more.parentElement.removeChild(more);
          }
        })
        .catch(function () { more.disabled = false; });
    });

    /* Colorway dots — catalog-wide sibling discovery (client 2026-07-24).
       The server-side table only sees this collection's first 48 products,
       but colorway families on this 2,500-product store often share no
       collection at all (Essential Tank Black ↔ Honeybutter share zero).
       Each colorway card lazily asks predictive search for its title base
       and appends the missing siblings as photo dots; server-rendered hex
       dots stay put. Cached per base, 4 requests in flight max. */
    var sibCache = {};
    var sibActive = 0;
    var sibQueue = [];
    function sibPump() {
      while (sibActive < 4 && sibQueue.length) { sibActive++; sibQueue.shift()(); }
    }
    function sibFetch(base) {
      if (sibCache[base]) return sibCache[base];
      sibCache[base] = new Promise(function (resolve) {
        sibQueue.push(function () {
          fetch("/search/suggest.json?q=" + encodeURIComponent(base) + "&resources[type]=product&resources[limit]=10")
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var out = [];
              ((((d || {}).resources || {}).results || {}).products || []).forEach(function (p) {
                if (p.title && p.title.indexOf(" - ") > -1 && p.title.split(" - ")[0].trim() === base) out.push(p);
              });
              resolve(out);
            })
            .catch(function () { resolve([]); })
            .then(function () { sibActive--; sibPump(); });
        });
        sibPump();
      });
      return sibCache[base];
    }
    function sibImg(p, w) {
      var u = (p.featured_image && p.featured_image.url) || p.image || "";
      if (!u) return "";
      return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
    }
    // Dots show COLORS only (client 2026-08-07: no product photos in
    // swatches) — unmapped colorway names get the neutral chip, never a crop.
    function sibUpgrade(span, matches) {
      var selfPath = (span.getAttribute("data-sib-url") || "").split("?")[0];
      var seen = {};
      seen[selfPath] = true;
      span.querySelectorAll(".rcard__swatch").forEach(function (d) {
        var href = d.getAttribute("href");
        if (href) seen[href.split("?")[0]] = true;
      });
      var fresh = matches.filter(function (p) { return !seen[(p.url || "").split("?")[0]]; });
      if (!fresh.length) return;
      var count = span.querySelectorAll(".rcard__swatch").length;
      if (count === 0) {
        var dot = document.createElement("span");
        dot.className = "rcard__swatch is-active";
        dot.title = span.getAttribute("data-sib-color") || "";
        var hex = span.getAttribute("data-sib-hex") || (window.gauiColorBg && window.gauiColorBg(dot.title)) || "";
        if (hex) dot.style.background = hex;
        else dot.style.background = "#D1CEC8";
        span.appendChild(dot);
        count = 1;
      }
      fresh.forEach(function (p) {
        if (count >= 5) return;
        var a = document.createElement("a");
        a.className = "rcard__swatch";
        a.href = (p.url || "").split("?")[0];
        var color = p.title.split(" - ").pop().trim();
        a.title = color;
        a.setAttribute("aria-label", span.getAttribute("data-sib-base") + " — " + color);
        var bg = window.gauiColorBg && window.gauiColorBg(color);
        if (bg) { a.style.background = bg; }
        else { a.style.background = "#D1CEC8"; }
        var img600 = sibImg(p, 600);
        if (img600) a.setAttribute("data-swatch-img", img600);
        span.appendChild(a);
        count++;
      });
      if (count > 1) {
        span.removeAttribute("aria-hidden");
        span.setAttribute("role", "group");
        span.setAttribute("aria-label", span.getAttribute("data-sib-base") + " — " + count + " colors");
      }
    }
    function sibSee(span) {
      sibFetch(span.getAttribute("data-sib-base")).then(function (m) { sibUpgrade(span, m); });
    }
    /* No IntersectionObserver gating: the theme-editor preview iframe (where
       the client reviews) doesn't reliably fire IO callbacks. All bases warm
       on load through the 4-lane queue, nearest-the-viewport first; the base
       cache keeps it to one request per family. */
    function sibWatch() {
      var fresh = [];
      root.querySelectorAll("[data-sib-base]").forEach(function (s) {
        if (s.hasAttribute("data-sib-armed")) return;
        s.setAttribute("data-sib-armed", "");
        fresh.push(s);
      });
      fresh
        .sort(function (a, b) { return Math.abs(a.getBoundingClientRect().top) - Math.abs(b.getBoundingClientRect().top); })
        .forEach(sibSee);
    }
    sibWatch();
    if (grid) new MutationObserver(function () { sibWatch(); }).observe(grid, { childList: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-guide"] && !Shopify.designMode) return;
  try {
    
  // Delegated at document level so the tabs survive theme-editor section
  // re-renders / hidden-section peeks, where the [data-gd] root is injected
  // after this script has already run.
  document.addEventListener("click", function (e) {
    var tab = e.target.closest("[data-gd-tab]");
    if (!tab) return;
    var root = tab.closest("[data-gd]");
    if (!root) return;
    var idx = tab.getAttribute("data-gd-tab");
    root.querySelectorAll("[data-gd-tab]").forEach(function (t) { t.classList.toggle("is-active", t === tab); });
    root.querySelectorAll("[data-gd-panel]").forEach(function (p) { p.hidden = p.getAttribute("data-gd-panel") !== idx; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll("[data-product-section]").forEach(function (root) {
    // Read more
    var moreBtn = root.querySelector("[data-pd-more-btn]");
    var moreTxt = root.querySelector("[data-pd-more]");
    if (moreBtn && moreTxt) {
      moreBtn.addEventListener("click", function () {
        moreTxt.hidden = !moreTxt.hidden;
        moreBtn.textContent = moreTxt.hidden ? "Read more" : "Read less";
      });
    }

    // Catalog-wide colorway discovery (client 2026-08-05: "color swatches
    // not populating correctly"). The server row only sees siblings inside
    // one collection; this asks predictive search for the title base and
    // appends the rest — same engine as the PLP grid + home rails. Hexes
    // come from window.gauiColorBg (theme.liquid); unknown names get the
    // neutral chip (client 2026-08-07: no product photos in swatches, ever).
    var cwWrap = root.querySelector(".pd__cw-dots[data-sib-base]");
    if (cwWrap) {
      var cwBase = cwWrap.getAttribute("data-sib-base");
      var cwSeen = {};
      cwSeen[(cwWrap.getAttribute("data-sib-url") || "").split("?")[0]] = true;
      cwWrap.querySelectorAll("a.pd__cw-dot").forEach(function (a) {
        cwSeen[(a.getAttribute("href") || "").split("?")[0]] = true;
      });
      fetch("/search/suggest.json?q=" + encodeURIComponent(cwBase) + "&resources[type]=product&resources[limit]=10")
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var matches = ((((d || {}).resources || {}).results || {}).products || []).filter(function (p) {
            return p.title && p.title.indexOf(" - ") > -1 && p.title.split(" - ")[0].trim() === cwBase;
          });
          var count = cwWrap.querySelectorAll(".pd__cw-dot").length;
          matches.forEach(function (p) {
            var path = (p.url || "").split("?")[0];
            if (cwSeen[path] || count >= 6) return;
            cwSeen[path] = true;
            var a = document.createElement("a");
            a.className = "pd__cw-dot";
            a.href = path;
            var color = p.title.split(" - ").pop().trim();
            a.title = color;
            a.setAttribute("aria-label", cwBase + " — " + color);
            var bg = window.gauiColorBg && window.gauiColorBg(color);
            if (bg) { a.style.background = bg; }
            else { a.style.background = "#D1CEC8"; }
            cwWrap.appendChild(a);
            count++;
          });
          if (count > 1) cwWrap.setAttribute("aria-label", cwBase + " — " + count + " colors");
        })
        .catch(function () {});
    }

    // Mobile swipe gallery <-> progress bars sync
    var viewport = root.querySelector("[data-pd-viewport]");
    var bars = root.querySelectorAll("[data-bar-index]");
    if (viewport && bars.length) {
      var setBar = function (idx) {
        bars.forEach(function (b, i) { b.classList.toggle("is-active", i === idx); });
      };
      viewport.addEventListener("scroll", function () {
        if (window.innerWidth >= 990) return;
        var idx = Math.round(viewport.scrollLeft / viewport.clientWidth);
        setBar(idx);
      }, { passive: true });
      bars.forEach(function (b, i) {
        b.addEventListener("click", function () {
          if (window.innerWidth < 990) {
            viewport.scrollTo({ left: i * viewport.clientWidth, behavior: "smooth" });
          }
        });
      });
    }

    // ATC "Adding..." pulse (cart.js opens the drawer on success)
    var form = root.querySelector('form[action*="/cart/add"]');
    var atcText = root.querySelector("[data-atc-text]");
    if (form && atcText) {
      form.addEventListener("submit", function () {
        var prev = atcText.innerHTML;
        atcText.textContent = "Adding...";
        setTimeout(function () { atcText.innerHTML = prev; }, 1400);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotted-in-gaui"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll("[data-hspot]").forEach(function (root) {
    var next = root.querySelector("[data-hspot-next]");
    var rail = root.querySelector("[data-hspot-rail]");
    if (next && rail) {
      next.addEventListener("click", function () {
        rail.scrollBy({ left: 312, behavior: "smooth" });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
